export const imageTypes = ['jpg', 'jpeg', 'png', 'bmp', 'webp', 'svg'];
export const videoTypes = ['avi', 'mp4', 'mkv', 'webm', 'mov'];

export function extname(path: string) {
  return (path.match(/(\.)(?!.*\.)\S+$/) || [])[0];
}

/**
 *
 * @param ext - file extension example `.jpg`
 * @param exts - extensions to test example `['jpg', 'jpeg', 'png', 'bmp', 'webp', 'svg']`
 */
export function extVerify(ext: string, exts: string[]) {
  return !!ext.replaceAll('.', '').match(new RegExp(`(${exts.join('|')})`, 'i'));
}

export function isImage(ext: string) {
  return extVerify(ext, imageTypes);
}

export function isVideo(ext: string) {
  return extVerify(ext, videoTypes);
}
